import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TAXONOMY } from "@/data/taxonomy";
import { CATEGORY_IMAGES, FALLBACK_CATEGORY_IMAGE } from "@/data/categoryImages";

export default function Categories() {
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="overline text-gray-500">Every service on Servrevu</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter mt-2">
            All categories
          </h1>
          <p className="text-gray-600 mt-3 max-w-2xl">
            Browse every subcategory of every group. Click any tile to see the matching businesses in the directory.
          </p>
        </div>
        <Link to="/directory" className="text-sm text-[#B31E1E] hover:underline font-medium" data-testid="see-all-listings-link">
          See all listings →
        </Link>
      </div>

      <div className="mt-12 space-y-14">
        {TAXONOMY.map((t) => {
          const groupImg = CATEGORY_IMAGES[t.group] || FALLBACK_CATEGORY_IMAGE;
          return (
            <section key={t.group} data-testid={`category-section-${t.group}`}>
              <div className="flex items-end justify-between gap-4 flex-wrap mb-5">
                <h2 className="font-display text-3xl tracking-tight">{t.group}</h2>
                <Link
                  to={`/directory?category=${encodeURIComponent(t.group)}`}
                  className="text-xs text-[#B31E1E] hover:underline font-medium inline-flex items-center gap-1"
                  data-testid={`category-group-link-${t.group}`}
                >
                  Browse all of {t.group} <ArrowRight size={12} />
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                {t.items.map((item) => {
                  const img = CATEGORY_IMAGES[item] || groupImg;
                  return (
                    <Link
                      key={item}
                      to={`/directory?category=${encodeURIComponent(item)}`}
                      className="group relative block aspect-[5/4] overflow-hidden rounded-[35px] border border-border bg-gray-100 transition-all hover:shadow-lg hover:-translate-y-0.5 hover:border-[#B31E1E]/40"
                      data-testid={`subcategory-tile-${item}`}
                    >
                      <img
                        src={img}
                        alt={item}
                        loading="lazy"
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-black/[0.54]" />
                      <div className="absolute inset-0 flex flex-col items-center justify-center p-3 text-center">
                        <p className="font-raleway font-bold text-base text-white tracking-tight drop-shadow-[0_1px_4px_rgba(0,0,0,0.85)]">
                          {item}
                        </p>
                        <span className="mt-1 inline-flex items-center gap-1 text-[11px] uppercase tracking-wider text-white/80 opacity-0 group-hover:opacity-100 transition-opacity">
                          Browse <ArrowRight size={12} />
                        </span>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>

      <div className="mt-16 pt-10 border-t border-border text-center">
        <p className="text-gray-600">Don't see your service?</p>
        <Link to="/list-your-business" className="mt-2 inline-flex items-center gap-1 text-[#B31E1E] hover:underline font-medium" data-testid="categories-list-business">
          List your business (free) <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
